import { Component } from '@angular/core';
import { OutlookSkeletonLineComponent } from './skeleton-line.component';

@Component({
  selector: 'maximizer-outlook-skeleton-timeline',
  template: `
    <div class="w-full flex flex-col rounded">
      <maximizer-outlook-skeleton
        containerClasses="h-8 w-full rounded-t bg-neutral-20 border-b border-neutral-5"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-28 w-full rounded-b bg-neutral-20"
      ></maximizer-outlook-skeleton>
    </div>
  `,
  imports: [OutlookSkeletonLineComponent],
})
export class OutlookSkeletonTimelineComponent {}
